import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import Swal from 'sweetalert2';
import API_BASE_URL, { API_IMAGE_BASE_URL } from '../../api/config';
import COLLEGE_MAP from '../../constants/colleges';


console.log("StudentsData COMPONENT LOADED");

// --- SVG Icons ---
const SearchIcon = () => (
    <svg className="search-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
    </svg>
);
const BackIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" width="16" height="16">
        <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
    </svg>
);
const ListIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" width="18" height="18">
        <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
    </svg>
);
const GridIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" width="18" height="18">
        <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6A2.25 2.25 0 016 3.75h2.25A2.25 2.25 0 0110.5 6v2.25a2.25 2.25 0 01-2.25 2.25H6a2.25 2.25 0 01-2.25-2.25V6zM3.75 15.75A2.25 2.25 0 016 13.5h2.25a2.25 2.25 0 012.25 2.25V18a2.25 2.25 0 01-2.25 2.25H6A2.25 2.25 0 013.75 18v-2.25zM13.5 6a2.25 2.25 0 012.25-2.25H18A2.25 2.25 0 0120.25 6v2.25A2.25 2.25 0 0118 10.5h-2.25a2.25 2.25 0 01-2.25-2.25V6zM13.5 15.75a2.25 2.25 0 012.25-2.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25h-2.25A2.25 2.25 0 0113.5 18v-2.25z" />
    </svg>
);

const REVERSE_COLLEGE_MAP = Object.fromEntries(
    Object.entries(COLLEGE_MAP).map(([key, value]) => [
        value.toLowerCase(),
        key
    ])
);


const StudentsData = () => {
    const [allData, setAllData] = useState({ students: [], facilitators: [], areaLeaders: [] });
    const [collegesList, setCollegesList] = useState([]);
    const [filteredCollegesList, setFilteredCollegesList] = useState([]);
    const [selectedCollege, setSelectedCollege] = useState(null);
    const [searchText, setSearchText] = useState('');
    const [userEmail, setUserEmail] = useState('');
    const [userName, setUserName] = useState('');
    const [userRole, setUserRole] = useState('');
    const [campRegistrations, setCampRegistrations] = useState([]);
    const [reportData, setReportData] = useState([]);
    const [selectedParticipantDetail, setSelectedParticipantDetail] = useState(null);
    const [areaOfAreaLeader, setAreaofAreaLeader] = useState(null);
    const [dataLoaded, setDataLoaded] = useState(false);

    const PhoneIcon = () => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4"><path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" /></svg>;
    const MailIcon = () => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4"><path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" /></svg>;
    const MapIcon = () => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4"><path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" /><path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" /></svg>;
    const SchoolIcon = () => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4"><path strokeLinecap="round" strokeLinejoin="round" d="M4.26 10.147a60.436 60.436 0 00-.491 6.347A48.627 48.627 0 0112 20.904a48.627 48.627 0 018.232-4.41 60.46 60.46 0 00-.491-6.347m-15.482 0a50.57 50.57 0 00-2.658-.813A59.905 59.905 0 0112 3.493a59.902 59.902 0 0110.499 5.216 50.59 50.59 0 00-2.658.813m-15.482 0A50.697 50.697 0 0112 13.489a50.702 50.702 0 017.74-3.342M6.75 15a.75.75 0 100-1.5.75.75 0 000 1.5zm0 0v-3.675A55.378 55.378 0 0112 8.443m-7.007 11.55A5.981 5.981 0 006.75 15.75v-1.5" /></svg>;
    const SkillsIcon = () =>  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4"><path strokeLinecap="round" strokeLinejoin="round" d="M10.5 6h3m-3 0a2.25 2.25 0 00-2.25 2.25v1.5m5.25-3.75a2.25 2.25 0 012.25 2.25v1.5M6.75 12h10.5m-9 6.75h7.5a2.25 2.25 0 002.25-2.25v-3.75a2.25 2.25 0 00-2.25-2.25H8.25A2.25 2.25 0 006 12.75v3.75a2.25 2.25 0 002.25 2.25z" /></svg>;
    const BirthdayIcon = () =>  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4"><path strokeLinecap="round" strokeLinejoin="round" d="M12 3v3m0 0c.828 0 1.5-.672 1.5-1.5S12.828 3 12 3s-1.5.672-1.5 1.5S11.172 6 12 6zm-6 6h12m-12 0v6.75A2.25 2.25 0 008.25 21h7.5A2.25 2.25 0 0018 18.75V12m-12 0l1.5-1.5m9 1.5l-1.5-1.5"/></svg>;

    const [showColleges, setShowColleges] = useState(true);
    const [showFacilitatorsForCollege, setShowFacilitatorsForCollege] = useState(false);
    const [showStudentsForFacilitator, setShowStudentsForFacilitator] = useState(false);
    const [selectedFacilitator, setSelectedFacilitator] = useState(null); 
    const [selectedFacilitatorDetail, setSelectedFacilitatorDetail] = useState(null); 

    const [viewMode, setViewMode] = useState('table'); 

    useEffect(() => {
        const email = Cookies.get('email');
        const role = Cookies.get('role');
        if (!email || !role) {
            Swal.fire({
                icon: 'error',
                title: 'Access Denied',
                text: 'Please login again',
            });
            return;
        }
        setUserEmail(email.trim().toLowerCase());
        setUserRole(role.trim().toLowerCase()); // Safety lowercase
    }, []);

    useEffect(() => {
        if (!userEmail || !userRole) return;
        const loadData = async () => {
            const data = await fetchAllData();
            setAllData(data);
            setDataLoaded(true);
        };
        loadData();
    }, [userEmail, userRole]);

    useEffect(() => {


        if (userRole === 'facilitator') {
            initFacilitator();
            initializeDataForFacilitator();
        } else if (userRole === 'area_leader') {
            initAreaLeader();
            initializeDataForAreaLeader(); 
        } else if (userRole === 'admin') {
            setUserName('Admin');
            initializeDataForAdmin();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataLoaded]);

    useEffect(() => {
        const filtered = collegesList.filter((college) =>
            college.toLowerCase().includes(searchText.toLowerCase())
        );
        setFilteredCollegesList(filtered);
    }, [searchText, collegesList]);

    const initializeDataForAdmin = async () => {
        const data = await fetchAllData();
        const uniqueColleges = getUniqueColleges(data);
        const R_data = await fetchReportsData();
        setAllData(data);
        setCollegesList(uniqueColleges);
        setFilteredCollegesList(uniqueColleges);
        setReportData(R_data);
        fetchCampRegistrations();
    };

    const initializeDataForFacilitator = async () => {
        const data = await fetchAllData();
        setAllData(data);
        const R_data = await fetchReportsData();
        setReportData(R_data);
        fetchCampRegistrations();
    };

    const initializeDataForAreaLeader = async () => {
        const R_data = await fetchReportsData();
        setReportData(R_data);
        fetchCampRegistrations();
    };

    const fetchAllData = async () => {
        try {
            const [studentsRes, usersRes] = await Promise.all([
                fetch(`${API_BASE_URL}/api/profile/read`),
                fetch(`${API_BASE_URL}/api/sign_up/read`)
            ]);
            const students = await studentsRes.json();
            const users = await usersRes.json();
            
            // FIX: Safely map uppercase database properties to lowercase so React can find them
            return {
                students,
                facilitators: users.filter(u => {
                    const r = (u.role || u.Role || '').toLowerCase();
                    const approved = String(u.role_approved || u.Role_Approved || u.Approved || u.approved);
                    return r === 'facilitator' && approved === '1';
                }),
                areaLeaders: users.filter(u => {
                    const r = (u.role || u.Role || '').toLowerCase();
                    const approved = String(u.role_approved || u.Role_Approved || u.Approved || u.approved);
                    return r === 'area_leader' && approved === '1';
                })
            };
        } catch (err) {
            console.error(err);
            return { students: [], facilitators: [], areaLeaders: [] };
        }
    };

    const initFacilitator = () => {
        // FIX: Safely check for Email or email
        const facilitator = allData.facilitators.find(f => (f.Email || f.email || '').toLowerCase().trim() === userEmail);
        if (!facilitator) return;
        
        setUserName(facilitator.username || facilitator.Full_Name || facilitator.name);
        setSelectedCollege(facilitator.Area || facilitator.area); 

        setShowColleges(false);
        setShowFacilitatorsForCollege(false);
        setShowStudentsForFacilitator(true);
    };

    const normalizeCollege = (value) => {
        if (!value) return '';
        const v = value.toLowerCase().trim();
        if (COLLEGE_MAP[v]) return v; // returns full name
        if (REVERSE_COLLEGE_MAP[v]) return REVERSE_COLLEGE_MAP[v]; // returns short code
        return v;
    };

    const initAreaLeader = () => {
        // FIX: Safely check for Email or email
        const leader = allData.areaLeaders.find(l => (l.Email || l.email || '').toLowerCase().trim() === userEmail);
        
        if (!leader) {
            console.warn("Area Leader not found for email:", userEmail);
            return;
        }

        const leaderArea = leader.Area || leader.area || '';
        const normalizedArea = normalizeCollege(leaderArea);

        setUserName(leader.username || leader.Full_Name || leader.name || '');
        setAreaofAreaLeader(normalizedArea);
        setSelectedCollege(normalizedArea);

        // Render both Area Students block AND Facilitators block
        setShowColleges(true); 
        setShowFacilitatorsForCollege(true);
        setShowStudentsForFacilitator(false);
    };

    const getUniqueColleges = (data) => {
        const studentColleges = data.students.map(student => student.college);
        const facilitatorAreas = data.facilitators.map(f => f.Area || f.area);
        const areaLeaderAreas = data.areaLeaders.map(l => l.Area || l.area);
        const allNames = [...studentColleges, ...facilitatorAreas, ...areaLeaderAreas];
        return [...new Set(allNames.filter(Boolean))].sort();
    };

    const fetchReportsData = async () => {
        try {
            const res = await fetch(`${API_BASE_URL}/api/Facilitator_Panel/Read_Report`);
            const data = await res.json();

            return (Array.isArray(data) ? data : []).map(r => ({
                Student_ID: r.Student_ID || r.student_id,
                Sincerity: r.Sincerity || r.sincerity || 0,
                Chanting: r.Chanting || r.chanting || 0,
                Need: r.Need || r.need || '',
                Interest: r.Interest || r.interest || '',
                Concern: r.Concern || r.concern || '',
                Remarks: r.Remarks || r.remarks || '',
                Last_Report: r.Last_Report || r.last_report || '',
                Book_Completed: r.Book_Completed || r.book_completed || '',
                Book_Alloted: r.Book_Alloted || r.book_alloted || '',
                Course_Completed: r.Course_Completed || r.course_completed || '',
                Course_Enrolled: r.Course_Enrolled || r.course_enrolled || ''
            }));

        } catch (error) {
            console.error(error);
            return [];
        }
    };


    const fetchCampRegistrations = async () => {
        try {
            const res = await fetch(`${API_BASE_URL}/api/Facilitator_Panel/Camp_Registration_Check`);
            const data = await res.json();
            setCampRegistrations(data);
        } catch (error) { console.error(error); }
    };

    const getRegisteredCamps = (participant) => {
        const registrations = campRegistrations.find((camp) => camp.email === participant.email);
        return (registrations && Array.isArray(registrations.camps)) ? registrations.camps.map(camp => camp.camp_name) : [];
    };

    const handleViewListClick = (college) => {
        setSelectedCollege(college);
        if (userRole === 'facilitator') {
            setShowColleges(false);
            setShowFacilitatorsForCollege(false);
            setShowStudentsForFacilitator(true);
        } else if (userRole === 'area_leader') {
            setShowColleges(false);
            setShowFacilitatorsForCollege(false);
            setShowStudentsForFacilitator(true);
            setSelectedFacilitator(null);
        } else {
            setShowColleges(false);
            setShowFacilitatorsForCollege(true);
            setShowStudentsForFacilitator(false);
            setSelectedFacilitator(null);
        }
    };

    const handleBackToColleges = () => {
        setShowColleges(true);
        setShowFacilitatorsForCollege(userRole === 'area_leader'); // Area leader goes back to seeing facilitators
        setShowStudentsForFacilitator(false);
        if(userRole === 'admin') setSelectedCollege(null);
        setSelectedFacilitator(null);
        setSearchText('');
    };

    const handleViewDetailClick = (participant) => {

        const reportEntry = reportData.find(
            r => String(r.Student_ID) === String(participant.user_id)
        );

        setSelectedParticipantDetail({
            ...participant,

            Chanting: reportEntry?.Chanting ?? 0,
            sincerity: reportEntry?.Sincerity ?? 0,

            Need: reportEntry?.Need ?? 'N/A',
            Interest: reportEntry?.Interest ?? 'N/A',
            Concern: reportEntry?.Concern ?? 'N/A',

            Book_Completed: reportEntry?.Book_Completed ?? 'N/A',
            Book_Alloted: reportEntry?.Book_Alloted ?? 'N/A',

            Course_Completed: reportEntry?.Course_Completed ?? 'N/A',
            Course_Enrolled: reportEntry?.Course_Enrolled ?? 'N/A',

            Remarks: reportEntry?.Remarks ?? 'N/A',
            Last_Report: reportEntry?.Last_Report ?? 'N/A'
        });
    };
    
    const handleCloseDetailModal = () => setSelectedParticipantDetail(null);
    const handleCloseFacilitatorDetailModal = () => setSelectedFacilitatorDetail(null);

    const handleViewStudentsForFacilitatorClick = (facilitator) => {
        setSelectedFacilitator(facilitator);
        setShowStudentsForFacilitator(true);
        setShowFacilitatorsForCollege(false);
        setShowColleges(false);
    };

    const handleApproveParticipant = async (participantId) => {
        try {
            const formData = new FormData();
            formData.append('user_id', participantId);
            const response = await fetch(`${API_BASE_URL}/api/Facilitator_Panel/update_approval`, { method: 'POST', body: formData });
            const contentType = response.headers.get("content-type");
            let success = false;
            let msg = '';
            
            if (contentType && contentType.indexOf("application/json") !== -1) {
                const result = await response.json();
                if(result.success) success = true;
                msg = result.message;
            } else {
                const textResult = await response.text();
                if (response.ok) success = true;
                msg = textResult;
            }

            if(success) {
                Swal.fire('Approved!', 'Participant has been approved.', 'success');
                setAllData(prev => ({
                    ...prev,
                    students: prev.students.map(s => String(s.user_id) === String(participantId) ? { ...s, FacilitatorApproved: '1' } : s)
                }));
            } else {
                Swal.fire('Error', msg || 'Failed to approve.', 'error');
            }
        } catch (error) {
             Swal.fire({ icon: 'error', title: 'Error', text: 'Approval failed.' });
        }
    };

    const ViewToggle = () => (
        <div className="view-toggle-container">
            <button 
                className={`view-toggle-btn ${viewMode === 'table' ? 'active' : ''}`}
                onClick={() => setViewMode('table')}
                title="Table View"
            >
                <ListIcon />
            </button>
            <button 
                className={`view-toggle-btn ${viewMode === 'card' ? 'active' : ''}`}
                onClick={() => setViewMode('card')}
                title="Card View"
            >
                <GridIcon />
            </button>
        </div>
    );

    const StudentCard = ({ student, reportEntry, onApprove, onViewDetail }) => {
        const camps = getRegisteredCamps(student);
        const isApproved = String(student.FacilitatorApproved) === '1';

        return (
            <div className="student-card">
                <div className="card-banner-bg"></div>
                
                <div className="card-content-wrapper">
                    <div className="card-profile-section">
                        <img
                            src={student.profile_image ? `${API_IMAGE_BASE_URL}/${student.profile_image}` : `https://ui-avatars.com/api/?name=${student.full_name}&background=random`}
                            alt="Profile"
                            className="card-avatar"
                        />
                        <div className="card-status-badge">
                            {isApproved ? 
                                <span className="status-dot approved" title="Approved"></span> : 
                                <span className="status-dot pending" title="Pending Approval"></span>
                            }
                        </div>
                    </div>

                    <div className="card-identity">
                        <h3 className="card-name">{student.full_name}</h3>
                        <div className="card-meta">
                            <span> {student.department || 'N/A'} {student.year_of_study || 'N/A'} </span>
                        </div>
                    </div>

                    <div className="card-stats-grid">
                        <div className="stat-box">
                            <span className="stat-label">Sincerity</span>
                            <span className="stat-value">{reportEntry?.Sincerity || student?.sincerity || '0'}%</span>
                        </div>
                        <div className="stat-box">
                            <span className="stat-label">Chanting</span>
                            <span className="stat-value">{reportEntry?.Chanting || student?.Chanting || student?.chanting || '0'}</span>
                        </div>
                        <div className="stat-box">
                            <span className="stat-label">Events</span>
                            <span className="stat-value">{camps.length}</span>
                        </div>
                    </div>

                    <div className="card-footer-actions">
                        <button className="btn-action-outline" onClick={() => onViewDetail(student)}>
                            View
                        </button>
                        {!isApproved && (
                            <button className="btn-action-fill" onClick={() => onApprove(student.user_id)}>
                                Approve
                            </button>
                        )}
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className="main">
            <div className="data-container">
                {showColleges && (
                    <>
                        {userRole === 'facilitator' ? (
                            <>
                                <div className="container-header">
                                    <h1 className="header-title">Students</h1>
                                </div>
                                <div className="table-wrapper">
                                    <table className="data-table">
                                        <thead>
                                            <tr><th>Sr. No.</th><th>College</th><th>My Students</th><th>Action</th></tr>
                                        </thead>
                                        <tbody>
                                            {[...new Set(allData.students.map(s => s.college).filter(Boolean))].map((college, index) => {
                                                const studentCount = allData.students.filter(s => s.college === college && s.Mentors_Name === userName).length;
                                                return (
                                                    <tr key={college}>
                                                        <td>{index + 1}</td>
                                                        <td>{COLLEGE_MAP[college] || college}</td>
                                                        <td>{studentCount}</td>
                                                        <td><button className="btn btn-primary" onClick={() => handleViewListClick(college)}>View Students</button></td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </>
                        ) : userRole === 'area_leader' ? (
                            <>
                                <div className="container-header">
                                    <h1 className="header-title">Students in Your Area</h1>
                                    <div className="header-actions">
                                        <ViewToggle />
                                    </div>
                                </div>
                                {(() => {
                                    // FIX: Secure comparison regardless of how college maps evaluate
                                    const areaStudents = allData.students.filter(
                                        student => normalizeCollege(student.college) === areaOfAreaLeader
                                    );
                                    
                                    if(viewMode === 'card') {
                                        return (
                                            <div className="card-grid">
                                                {areaStudents.map((student) => {
                                                    const reportEntry = Array.isArray(reportData) ? reportData.find(r => String(r.Student_ID || r.student_id) === String(student.user_id)) : null;
                                                    return (
                                                        <StudentCard 
                                                            key={student.user_id} 
                                                            student={student} 
                                                            reportEntry={reportEntry}
                                                            onApprove={handleApproveParticipant}
                                                            onViewDetail={handleViewDetailClick}
                                                        />
                                                    )
                                                })}
                                            </div>
                                        )
                                    }

                                    return (
                                        <div className="table-wrapper">
                                            <table className="data-table">
                                                <thead>
                                                    <tr><th>Sr. No.</th><th>Student</th><th>Mentor Name</th><th>Action</th></tr>
                                                </thead>
                                                <tbody>
                                                    {areaStudents.map((student, index) => (
                                                        <tr key={student.user_id || index}>
                                                            <td>{index + 1}</td>
                                                            <td>{student.full_name || 'N/A'}</td>
                                                            <td>{student.Mentors_Name || 'N/A'}</td>
                                                            <td><button className="btn btn-primary" onClick={() => handleViewDetailClick(student)}>View Details</button></td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    )
                                })()}
                            </>
                        ) : (
                            /* Admin View for Colleges */
                            <>
                                <div className="container-header">
                                    <h1 className="header-title">Colleges</h1>
                                    <div className="search-box">
                                        <SearchIcon /><input type="text" placeholder="Search colleges..." value={searchText} onChange={(e) => setSearchText(e.target.value)} className="search-input"/>
                                    </div>
                                </div>
                                <div className="table-wrapper">
                                    <table className="data-table">
                                        <thead><tr><th>Sr. No.</th><th>College</th><th>Area Leader</th><th>Total Facilitators</th><th>Total Students</th><th>Action</th></tr></thead>
                                        <tbody>
                                            {filteredCollegesList.map((college, index) => {
                                                const totalStudents = allData.students.filter(p => p.college === college).length;
                                                const totalFacilitators = allData.facilitators.filter(p => (p.Area || p.area) === college).length;
                                                const areaLeader = allData.areaLeaders.find(leader => normalizeCollege(leader.Area || leader.area) === normalizeCollege(college));
                                                return (
                                                    <tr key={college}>
                                                        <td>{index + 1}</td>
                                                        <td>{COLLEGE_MAP[college] || college}</td>
                                                        <td>{areaLeader ? (areaLeader.username || areaLeader.Full_Name || areaLeader.name) : 'N/A'}</td>
                                                        <td>{totalFacilitators}</td>
                                                        <td>{totalStudents}</td>
                                                        <td><button className="btn btn-primary" onClick={() => handleViewListClick(college)}>View List</button></td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </>
                        )}
                    </>
                )}

                {showFacilitatorsForCollege && (userRole === 'area_leader' || userRole === 'admin') && (
                    <>
                        <div className="container-header" style={{ marginTop: '24px' }}>
                            <h1 className="header-title">FACILITATORS - {COLLEGE_MAP[selectedCollege] || selectedCollege}</h1>
                            <div className="header-actions">
                                {userRole === 'admin' && <button onClick={handleBackToColleges} className="btn btn-secondary"><BackIcon /> Back to Colleges</button>}
                            </div>
                        </div>
                        <div className="table-wrapper">
                            <table className="data-table">
                                <thead><tr><th>Sr. No.</th><th>Facilitator</th><th>Total Students</th><th>Action</th></tr></thead>
                                <tbody>
                                    {allData.facilitators.filter(f => (f.Area || f.area) === selectedCollege).map((facilitator, index) => {
                                        const facilitatorName = facilitator.username || facilitator.Full_Name || facilitator.name;
                                        const totalStudents = allData.students.filter(s => s.Mentors_Name === facilitatorName && s.college === selectedCollege).length;
                                        return (
                                            <tr key={facilitator.Email || facilitator.email || index}>
                                                <td>{index + 1}</td>
                                                <td>{facilitatorName}</td>
                                                <td>{totalStudents}</td>
                                                <td><button className="btn btn-primary" onClick={() => handleViewStudentsForFacilitatorClick(facilitator)}>View Students</button></td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </>
                )}

                {showStudentsForFacilitator && (
                    <>
                        <div className="container-header">
                            <h1 className="header-title">
                                {userRole === 'facilitator' ? `My Students - ${COLLEGE_MAP[selectedCollege] || selectedCollege}` : `Students - ${selectedFacilitator?.username || selectedFacilitator?.Full_Name || selectedFacilitator?.name}`}
                            </h1>
                            <div className="header-actions">
                                <ViewToggle />
                                {userRole !== 'facilitator' && (
                                    <button onClick={handleBackToColleges} className="btn btn-secondary">
                                        <BackIcon /> Back
                                    </button>
                                )}
                            </div>
                        </div>

                        {/* --- Logic for Table vs Card View for Students --- */}
                        {(() => {
                            let studentsToList = [];
                                if (userRole === 'facilitator') {
                                    studentsToList = allData.students.filter(
                                        student =>
                                            student.college === selectedCollege &&
                                            student.Mentors_Name === userName
                                    );
                                } else if (userRole === 'area_leader') {
                                    // Should be handled in showColleges view, but kept here as fallback
                                    studentsToList = allData.students.filter(
                                        student => normalizeCollege(student.college) === areaOfAreaLeader
                                    );
                                } else {
                                    const facName = selectedFacilitator?.username || selectedFacilitator?.Full_Name || selectedFacilitator?.name;
                                    studentsToList = allData.students.filter(
                                        student =>
                                            student.college === selectedCollege &&
                                            (!selectedFacilitator || student.Mentors_Name === facName)
                                    );
                                }

                            if (viewMode === 'card') {
                                return (
                                    <div className="card-grid">
                                        {studentsToList.map((student) => {
                                            const reportEntry = Array.isArray(reportData) ? reportData.find(r => String(r.Student_ID || r.student_id) === String(student.user_id)) : null;
                                            return (
                                                <StudentCard 
                                                    key={student.user_id} 
                                                    student={student} 
                                                    reportEntry={reportEntry}
                                                    onApprove={handleApproveParticipant}
                                                    onViewDetail={handleViewDetailClick}
                                                />
                                            )
                                        })}
                                    </div>
                                );
                            }

                            return (
                                <div className="table-wrapper">
                                    <table className="data-table">
                                        <thead>
                                            <tr>
                                                <th>Last update</th><th>Student</th><th>Course/Year</th>
                                                <th>Status</th><th>Events</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {studentsToList.map((student, index) => {
                                                const reportEntry = Array.isArray(reportData) ? reportData.find(r => String(r.Student_ID || r.student_id) === String(student.user_id)) : null;
                                                return (
                                                    <tr key={student.user_id}>
                                                        <td>{reportEntry?.Last_Report || 'N/A'}</td>
                                                        <td>{student.full_name}</td>
                                                        <td>{student.department || 'N/A'}/{student.year_of_study || 'N/A'}</td>
                                                        <td>
                                                            {String(student.FacilitatorApproved) === '1' ? 
                                                                <span className="status-pill status-approved">Approved</span> : 
                                                                ((userRole === 'facilitator' || userRole === 'area_leader') ? 
                                                                    <button className="btn btn-success" onClick={() => handleApproveParticipant(student.user_id)}>Approve</button> : 
                                                                    <span className="status-pill status-pending">No</span>)
                                                            }
                                                        </td>
                                                        <td>
                                                            {getRegisteredCamps(student).length > 0 ? 
                                                                <span className="status-pill status-registered">{getRegisteredCamps(student).join(', ')}</span> : 
                                                                <span className="status-pill status-not-registered"></span>
                                                            }
                                                        </td>
                                                        <td>
                                                            <button className="btn btn-primary" onClick={() => handleViewDetailClick(student)}>
                                                                View
                                                            </button>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            );
                        })()}
                    </>
                )}
            </div>

            {selectedParticipantDetail && (
                <div className="modal-overlay" onClick={handleCloseDetailModal}>
                    <div className="premium-modal" onClick={(e) => e.stopPropagation()}>
                        
                        <div className="modal-hero-banner">
                            <button className="modal-close-btn" onClick={handleCloseDetailModal}>
                                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
                            </button>
                            <div className="modal-profile-summary">
                                <img 
                                     src={selectedParticipantDetail.profile_image ? `${API_IMAGE_BASE_URL}/${selectedParticipantDetail.profile_image}` : `https://ui-avatars.com/api/?name=${selectedParticipantDetail.full_name}&background=random`} 
                                    alt="Profile" 
                                    className="modal-avatar"
                                />
                                <div className="modal-text-summary">
                                    <h2>{selectedParticipantDetail.full_name}</h2>
                                    <p className="modal-email"><MailIcon/> {selectedParticipantDetail.email}</p>
                                    <div className="modal-chips">
                                        <span className="chip">{selectedParticipantDetail.college}</span>
                                        <span className={`chip ${String(selectedParticipantDetail.FacilitatorApproved) === '1' ? 'chip-green' : 'chip-orange'}`}>
                                            {String(selectedParticipantDetail.FacilitatorApproved) === '1' ? 'Approved' : 'Pending Approval'}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="modal-scroll-content">
                            <div className="modal-grid-layout">
                                
                                <div className="modal-section">
                                    <h4 className="section-title">Personal Information</h4>
                                    <div className="info-row">
                                        <div className="info-icon"><PhoneIcon/></div>
                                        <div>
                                            <span className="info-label">Mobile</span>
                                            <p className="info-value">{selectedParticipantDetail.phone_number}</p>
                                        </div>
                                    </div>
                                    <div className="info-row">
                                        <div className="info-icon"><BirthdayIcon/></div>
                                        <div>
                                            <span className="info-label">Birthday</span>
                                            <p className="info-value">{selectedParticipantDetail.dob}</p>
                                        </div>
                                    </div>
                                    <div className="info-row">
                                        <div className="info-icon"><SchoolIcon/></div>
                                        <div>
                                            <span className="info-label">Academic Details</span>
                                            <p className="info-value">{selectedParticipantDetail.department}, {selectedParticipantDetail.year_of_study} Year</p>
                                        </div>
                                    </div>
                                    <div className="info-row">
                                        <div className="info-icon"><SkillsIcon/></div>
                                        <div>
                                            <span className="info-label">Skills</span>
                                            <p className="info-value">{selectedParticipantDetail.skills}</p>
                                        </div>
                                    </div>
                                    <div className="info-row">
                                        <div className="info-icon"><MapIcon/></div>
                                        <div>
                                            <span className="info-label">Address</span>
                                            <p className="info-value">{selectedParticipantDetail.address || 'Not Provided'}</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="modal-section">
                                    <h4 className="section-title">Facilitator Report</h4>
                                    <div className="stats-mini-grid">
                                        <div className="mini-stat">
                                            <span>Sincerity</span>
                                            <strong>{selectedParticipantDetail.sincerity}%</strong>
                                        </div>
                                        <div className="mini-stat">
                                            <span>Chanting</span>
                                            <strong>{selectedParticipantDetail.Chanting}</strong>
                                        </div>
                                    </div>
                                    
                                    <div className="report-card">
                                        <div className="report-item">
                                            <span className="report-label">Identified Need</span>
                                            <p className="report-text">{selectedParticipantDetail.Need || 'N/A'}</p>
                                        </div>
                                        <div className="report-item">
                                            <span className="report-label">Key Interest</span>
                                            <p className="report-text">{selectedParticipantDetail.Interest || 'N/A'}</p>
                                        </div>
                                        <div className="report-item concern">
                                            <span className="report-label">Concern</span>
                                            <p className="report-text">{selectedParticipantDetail.Concern || 'N/A'}</p>
                                        </div>
                                        <div className="report-item">
                                            <span className="report-label">Books Completed</span>
                                            <p className="report-text">{selectedParticipantDetail.Book_Completed || 'N/A'}</p>
                                        </div>
                                        <div className="report-item">
                                            <span className="report-label">Book Alloted</span>
                                            <p className="report-text">{selectedParticipantDetail.Book_Alloted || 'N/A'}</p>
                                        </div>
                                        <div className="report-item">
                                            <span className="report-label">Courses Completed</span>
                                            <p className="report-text">{selectedParticipantDetail.Course_Completed || 'N/A'}</p>
                                        </div>
                                        <div className="report-item">
                                            <span className="report-label">Course Enrolled</span>
                                            <p className="report-text">{selectedParticipantDetail.Course_Enrolled || 'N/A'}</p>
                                        </div>
                                    </div>
                                </div>
                            
                            </div>
                            
                            <div className="modal-section full-width">
                                <h4 className="section-title">Remarks & History</h4>
                                <div className="remarks-box">
                                    <p>"{selectedParticipantDetail.Remarks}"</p>
                                    <span className="timestamp">Last Report Updated: {selectedParticipantDetail.Last_Report}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {selectedFacilitatorDetail && (userRole === 'area_leader' || userRole === 'admin') && (
                <div className="modal-overlay" onClick={handleCloseFacilitatorDetailModal}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <button className="premium-close-button" onClick={handleCloseFacilitatorDetailModal}><svg className="close-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg></button>
                        <div className="modal-header"><h2>Facilitator Details</h2></div>
                        <div className="modal-body">
                            <div className="profile-main-info">
                                <img src={`https://ui-avatars.com/api/?name=${selectedFacilitatorDetail.Full_Name}&background=random`} alt="Facilitator Profile" className="profile-image-large"/>
                                <div className="profile-name-email"><h3>{selectedFacilitatorDetail.Full_Name || selectedFacilitatorDetail.username || selectedFacilitatorDetail.name}</h3><p>{selectedFacilitatorDetail.Email || selectedFacilitatorDetail.email}</p><p>Area: {selectedFacilitatorDetail.Area || selectedFacilitatorDetail.area}</p></div>
                            </div>
                            <div className="profile-details">
                                <div className="profile-detail"><strong>Phone:</strong> {selectedFacilitatorDetail.Mobile_Number || selectedFacilitatorDetail.phone_number}</div>
                                <div className="profile-detail"><strong>Approved:</strong> {String(selectedFacilitatorDetail.Approved || selectedFacilitatorDetail.role_approved) === "1" ? "Yes" : "No"}</div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default StudentsData;